<span
  class="avatar avatar-{{
    user && user.user_profile ? user.user_profile.avatar_color : 'blue'
  }}"
  >
  @if (
    user && user.user_profile && user.user_profile.avatar_photo) {
    <img [src]="getPhotoForDisplay()" />
  } @else {
    <span>{{ user && user.username ? user.username[0] : "" }}</span>
  }
</span>
